import { INBOX_RIGHT_ACTIONS } from "../../constants/actionsConstants";

const initialState = {
  customer: null,
  orderCounts: null,
  customerLoading: false,
  customerError: null,
  isCustomerDetailsEditing: false,
  ordersLoading: false,
  ordersError: null,
  leadScore: null,
  leadScoreLoading: false,
  leadScoreError: null,
  fieldCaptures: [],
  fieldCapturesLoading: false,
  fieldCapturesError: null
};

const inboxRightReducer = (state = initialState, action) => {
  switch (action.type) {
    case INBOX_RIGHT_ACTIONS.SET_CUSTOMER_DATA:
      return {
        ...state,
        customer: action.data,
        customerLoading: false,
        customerError: null
      };
    case INBOX_RIGHT_ACTIONS.UPDATE_CUSTOMER_DATA:
      return {
        ...state,
        customer: {
          ...state.customer,
          ...action.data
        }
      };
    case INBOX_RIGHT_ACTIONS.SET_CUSTOMER_LOADING:
      return {
        ...state,
        customerLoading: true,
        customerError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_CUSTOMER_DETAILS_EDITING:
      return {
        ...state,
        isCustomerDetailsEditing: Boolean(action.editing)
      };
    case INBOX_RIGHT_ACTIONS.SET_CUSTOMER_ERROR:
      return {
        ...state,
        customerLoading: false,
        customerError: action.error
      };
    case INBOX_RIGHT_ACTIONS.SET_ORDERS_COUNT:
      return {
        ...state,
        orderCounts: action.data,
        ordersLoading: false,
        ordersError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_ORDERS_LOADING:
      // Keep existing orderCounts while loading to avoid CustomerCard flash.
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_ORDERS_ERROR:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.error
      };
    case INBOX_RIGHT_ACTIONS.CLEAR_CUSTOMER_SIDEBAR:
      return {
        ...initialState
      };
    case INBOX_RIGHT_ACTIONS.SET_LEAD_SCORE:
      return {
        ...state,
        leadScore: action.payload,
        leadScoreLoading: false,
        leadScoreError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_LEAD_SCORE_LOADING:
      return {
        ...state,
        leadScoreLoading: action.payload,
        leadScoreError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_LEAD_SCORE_ERROR:
      return {
        ...state,
        leadScoreError: action.payload,
        leadScoreLoading: false
      };
    case INBOX_RIGHT_ACTIONS.SET_FIELD_CAPTURES:
      return {
        ...state,
        fieldCaptures: action.payload,
        fieldCapturesLoading: false,
        fieldCapturesError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_FIELD_CAPTURES_LOADING:
      return {
        ...state,
        fieldCapturesLoading: action.payload,
        fieldCapturesError: null
      };
    case INBOX_RIGHT_ACTIONS.SET_FIELD_CAPTURES_ERROR:
      return {
        ...state,
        fieldCapturesError: action.payload,
        fieldCapturesLoading: false
      };
    case INBOX_RIGHT_ACTIONS.ADD_FIELD_CAPTURE:
      return {
        ...state,
        fieldCaptures: [action.payload, ...state.fieldCaptures]
      };
    default:
      return state;
  }
};

export default inboxRightReducer;
